"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleImageWithAvatar = void 0;
var react_1 = __importDefault(require("react"));
var Upload_1 = __importDefault(require("../../../Upload"));
var SingleImageWithAvatarBase = Upload_1.default.SingleImageWithAvatar;
var SingleImageWithAvatar = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? "" : _b, componentProps = _a.componentProps;
    return (react_1.default.createElement(SingleImageWithAvatarBase, __assign({}, componentProps, { init: {
            fileSrc: value,
        }, on: {
            remove: function () {
                var _a, _b;
                onChange === null || onChange === void 0 ? void 0 : onChange("");
                (_b = (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.on) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
            },
            base64loaded: function (fileSrc) {
                var _a, _b;
                onChange === null || onChange === void 0 ? void 0 : onChange(fileSrc);
                (_b = (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.on) === null || _a === void 0 ? void 0 : _a.base64loaded) === null || _b === void 0 ? void 0 : _b.call(_a, fileSrc);
            },
        } })));
};
exports.SingleImageWithAvatar = SingleImageWithAvatar;
exports.default = exports.SingleImageWithAvatar;
